<template>
  <div class="search-filter">
    <a-form-model
      class="form"
      ref="form"
      :model="form"
      :label-col="{ flex: '0 0 130px' }"
      :wrapper-col="{ flex: '0 0 calc(100% - 130px)'}"
    >
      <a-row :gutter="16">
        <a-col :span="colSpan">
          <a-form-model-item label="主体(品牌)" prop="principalId">
            <a-select
              v-model="form.principalId"
              :default-active-first-option="false"
              option-filter-prop="children"
              show-search
              style="width: 100%;"
              @change="handlePrincipalChange"
            >
              <a-select-option
                v-for="item in principalList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-model-item label="大区" prop="regionId">
            <a-select
              v-model="form.regionId"
              :disabled="form.principalId === ''"
              :default-active-first-option="false"
              option-filter-prop="children"
              show-search
              style="width: 100%;"
            >
              <a-select-option
                v-for="item in regionList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-model-item label="经销商/公司名称" prop="nameOrCompanyName">
            <a-input
              v-model.trim="form.nameOrCompanyName"
              allow-clear
              placeholder="请输入经销商/公司名称"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-model-item label="经销商编码" prop="storeCode">
            <a-input
              v-model.trim="form.storeCode"
              allow-clear
              placeholder="请输入经销商编码"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan">
          <a-form-model-item label="公共分组" prop="publicGroupId">
            <a-select
              v-model="form.publicGroupId"
              :default-active-first-option="false"
              :filter-option="false"
              show-search
              style="width: 100%;" 
              @search="handleGroupSearch" 
            >
              <a-select-option
                v-for="item in groupList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan2">
          <a-form-model-item label="收录时间" prop="ctime">
            <div class="time-wrap">
               <a-button-group>
                <a-button
                  v-for="item in ctimeTypeList"
                  :key="item.value"
                  :type="item.value === ctimeType ? 'primary' : 'default'"
                  style="padding: 0 8px;"
                  @click="handleCtimeTypeChange(item.value)"
                >
                  {{ item.label }}
                </a-button>
              </a-button-group>
              <a-range-picker
                v-model="form.ctime"
                value-format="YYYY-MM-DD"
                @change="handleCtimeChange"
              />
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="colSpan3">
          <a-form-model-item :wrapper-col="{ flex: '1 0 auto' }">
            <div class="btn-wrap">
              <a-button class="mr-8" @click="handleReset">
                重置
              </a-button>
              <a-button type="primary" :loading="loading" @click="handleSearch">
                查询
              </a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import resizeMixin from "@/mixins/dataTableMixin";

const ctimeTypeList = [
  { label: '今天', value: 0 },
  { label: '近7天', value: 7 },
  { label: '近15天', value: 15 },
  { label: '近30天', value: 30 }
]

export default {
  name: 'SearchFilter',
  mixins: [resizeMixin],
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    fetchPrincipal: {
      type: Function,
      default() {
        return () => {}
      }
    },
    principalList: {
      type: Array,
      default() {
        return []
      }
    },
    fetchRegion: {
      type: Function,
      default() {
        return () => {}
      }
    },
    regionList: {
      type: Array,
      default() {
        return []
      }
    },
    fetchGroup: {
      type: Function,
      default() {
        return () => {}
      }
    },
    groupList: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.$_resizeHandler = () => {
      this.setColSpan()
    };

    return {
      ctimeType: '', // 0, 1, 7, 15, 30
      ctimeTypeList,
      colSpan: 12,
      colSpan2: 24,
      colSpan3: 24
    }
  },
  mounted() {
    this.fetchPrincipal()
    this.setColSpan()
  },
  methods: {
    handlePrincipalChange(val) {
      this.form.regionId = ''
      this.fetchRegion(val)
    },
    handleGroupSearch(searchText) {
      this.fetchGroup(searchText)
    },
    handleCtimeTypeChange(val) {
      if (val === this.ctimeType) {
        this.ctimeType = ''
        this.form.ctime = []
      } else {
        this.ctimeType = val

        if (this.ctimeType === 0) {
          this.form.ctime = [
            this.$moment().format('YYYY-MM-DD'),
            this.$moment().format('YYYY-MM-DD')
          ]
        } else {
          this.form.ctime = [
            this.$moment().subtract(this.ctimeType, 'days').format('YYYY-MM-DD'),
            this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
          ]
        }
      }
    },
    handleCtimeChange(val) {
      this.ctimeType = ''
    },
    setColSpan() {
      const width = document.documentElement.offsetWidth

      if (width < 1200) {
        this.colSpan = 12
        this.colSpan2 = 24
        this.colSpan3 = 24
      } else if (width >= 1200 && width < 1600) {
        this.colSpan = 8
        this.colSpan2 = 16
        this.colSpan3 = 8
      } else if (width >= 1600) {
        this.colSpan = 6
        this.colSpan2 = 12
        this.colSpan3 = 6
      }
    },
    handleReset() {
      this.$refs.form.resetFields()
      this.fetchRegion(this.form.principalId)
      this.fetchGroup('')
      this.ctimeType = ''
      this.$emit('search', {...this.form})
    },
    handleSearch() {
      this.$emit('search', {...this.form})
    }
  }
}
</script>

<style lang="scss" scoped>
.search-filter {
  padding: 24px 24px 16px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 2px;

  .ant-form-item {
    display: flex;
    margin-bottom: 8px;
  }

  .time-wrap {
    display: flex;
    align-items: center;
    height: 40px;

    .ant-btn-group {
      margin-right: 8px;
    }

    .ant-calendar-picker {
      flex: 1;
    }
  }

  .btn-wrap {
    text-align: right;
  }

  .mr-8 {
    margin-right: 8px;
  }
}
</style>
